import { IOfferState } from '../../../../reducers';

export const mapPartialRent = (offer: IOfferState) => {
  let { isRentByParts, rentByPartsDescription, category } = offer;

  // Если сдается дом целиком, не нужно передавать значение части
  if (!isRentByParts) {
    rentByPartsDescription = null;
  }

  // Только для сдачи посуточно доступна часть дома
  if (category !== 'dailyHouseRent') {
    isRentByParts = null;
    rentByPartsDescription = null;
  }

  return {
    isRentByParts,
    rentByPartsDescription,
  };
};
